<template>
  <SettingsDialog v-model="active">
    <div class="d-flex h-100 w-100">
      <SettingsDialogListGroup
        v-if="!isMobile || !active"
        v-model="active"
        :list="settingsList"
        :class="{'w-100': isMobile}"
      >
        <BootstrapButton
          id="settings.log-out"
          name="Log out"
          class="mt-auto text-danger"
          variant="ghost"
          :size="isMobile ? 'lg' : 'sm'"
          @click="logout"
        >
          <Icon icon="material-symbols:logout" />
          {{ translate('Log out') }}
        </BootstrapButton>
      </SettingsDialogListGroup>
      <section
        v-if="!isMobile || active"
        class="w-100 flex-grow-1 overflow-auto d-flex flex-column"
        :class="isMobile ? 'px-3 py-3' : 'px-5 py-4'"
      >
        <div class="d-flex align-items-center mb-3">
          <BootstrapButton
            v-if="isMobile"
            variant="ghost"
            :size="isMobile ? 'lg' : 'sm'"
            :aria-label="translate('Back')"
            class="py-1 ps-0 pe-2"
            @click="active = ''"
          >
            <Icon icon="material-symbols:arrow-back" />
          </BootstrapButton>
          <h5 class="mb-0">{{ translate(active) }}</h5>
        </div>

        <KeepAlive>
          <component :is="getComponentName(active)" :loading="loading" class="flex-grow-1" />
        </KeepAlive>
      </section>
    </div>
  </SettingsDialog>
</template>
<script lang="ts" setup>
import {useLocalisation} from '@/composables/useLocalisation';
import {useSettingsTabs} from '@/composables/useSettingsTabs';

import {logoutKey} from '@/injectionKeys';
import {settingsKey, SettingsKey} from '@/components/settings/injectionKeys';

const logout = inject(logoutKey);
const active = inject(settingsKey)!;

const {translate} = useLocalisation();
const {isMobile} = useBsBreakpoints();
const loading = ref(false); // TODO: Update/merge settings folder.

const componentMap = new Map<SettingsKey, Component>([
  ['Users', defineAsyncComponent(() => import('@/components/settings/UsersView/UsersView.vue'))],
  ['Profile', defineAsyncComponent(() => import('@/components/settings/ProfileView.vue'))],
  [
    'Notifications',
    defineAsyncComponent(() => import('@/components/settings/NotificationsView.vue')),
  ],
  ['Roles', defineAsyncComponent(() => import('@/components/settings/RolesView.vue'))],
  [
    'Products',
    defineAsyncComponent(() => import('@/components/settings/CustomerProductsView.vue')),
  ],
  [
    'Ekco Users',
    defineAsyncComponent(() => import('@/components/settings/EkcoUsersView/EkcoUsersView.vue')),
  ],
  [
    'Contacts',
    defineAsyncComponent(() => import('@/components/settings/ContactsView/ContactsView.vue')),
  ],
  [
    'Sources',
    defineAsyncComponent(() => import('@/components/settings/SourcesView/SourcesView.vue')),
  ],
  ['Feedback', defineAsyncComponent(() => import('@/components/settings/SendFeedbackView.vue'))],
  ['Performance', defineAsyncComponent(() => import('@/components/settings/PerformanceView.vue'))],
  [
    'Demo Customers',
    defineAsyncComponent(
      () => import('@/components/settings/DemoCustomerView/DemoCustomerView.vue'),
    ),
  ],
  [
    'Login Policy',
    defineAsyncComponent(() => import('@/components/loginPolicy/LoginPolicyApp.vue')),
  ],
]);
const getComponentName = (name: SettingsKey) => componentMap.get(name);

const {settingsList} = useSettingsTabs();
</script>
<style lang="scss" scoped>
.settings-list-group {
  margin-right: var(--bs-card-spacer-x);
}
</style>
